<script setup>
import ProgressBar from "./data/ProgressBar.vue";

const props = defineProps(["item", "isLoading", "titles"]);
</script>

<template>
  <v-container class="main-card pa-0">
    <v-card class="container mt-2" v-if="!props.isLoading">
      <v-card-text
        class="title green-header pa-0"
        align="center"
        style="overflow: hidden"
      >
        <span class="marquee" style="white-space: nowrap">
          {{ props.item.name }}
        </span>
      </v-card-text>
      <v-card class="custom-card mt-3">
        <v-row align="center" class="ma-0 mt-2">
          <ProgressBar
            :title="props.titles[0]"
            :percents="props.item.constructionplanfact.factpercentage"
            :size="0.55"
          />
        </v-row>
        <v-row align="center" class="ma-0 mt-2">
          <ProgressBar
            :title="props.titles[1]"
            :percents="props.item.constructionplanfact.planpercentage"
            :size="0.55"
          />
        </v-row>
        <v-row align="center" class="ma-0 mt-2">
          <ProgressBar
            :title="props.titles[2]"
            :percents="props.item.constructionplanfact.deviationpercentage"
            :size="0.55"
          />
        </v-row>
      </v-card>
    </v-card>
  </v-container>
</template>

<style scoped>
.main-card {
  position: absolute;
  background: radial-gradient(circle, #106595 20%, #001825 90%);
  top: 2em;
  right: 2em;
  z-index: 1;
  border-radius: 10px;
  width: 16vw;
  height: 170px;
}
.container {
  background-color: transparent;
}
.title {
  font-size: 1.3vw;
  overflow: hidden;
  display: block;
}
.custom-card {
  text-align: center;
  background-color: transparent;
}
.green-header {
  background: radial-gradient(closest-side, #1bc200, transparent);
}

.marquee {
  display: inline-block; /* Allow horizontal scrolling */
  animation: marquee 15s linear infinite; /* Adjust duration as needed */
}

@keyframes marquee {
  0% {
    transform: translateX(20%); /* Start position */
    opacity: 1;
  }
  85% {
    transform: translateX(-100%); /* End of scroll */
    opacity: 1;
  }
  95% {
    opacity: 0; /* Briefly hide text */
  }
  100% {
    opacity: 0; /* Keep hidden to create a short delay */
  }
}
</style>
